import React from 'react'
import { apiFetch } from '../fetchApi'

export const createLanguage = ({ BeURL, topInput, setLanguage, showAlert, handleTopClear, candidateId, setCandidate, profiles }) => {

    console.log("Profilessss:", profiles)
    if (!BeURL || !topInput || !setLanguage) {
        alert("BeURL, topInput or setLanguage is invalid")
        return
    }

    apiFetch(`${BeURL}/language`, {
        method: 'POST',

        body: JSON.stringify({ topInput, candidateId })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)

                setLanguage(data.languages)
                console.log("{ ...profiles, _id:data.candidates._id,languages: data.candidates.languages }", { ...profiles, _id: data.candidates._id, languages: data.candidates.languages })
                setCandidate({ ...profiles, _id:data.candidates._id,languages: data.candidates.languages })
                handleTopClear()
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error in create language", err)
            showAlert("Trouble")
        })


}
